import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextAlignmentRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.247 7.5a.75.75 0 0 0 0-1.5H3.767a.75.75 0 0 0 0 1.5zm.007 7a.75.75 0 0 0 0-1.5H3.776a.75.75 0 0 0 0 1.5zm.75-4.25a.75.75 0 0 1-.75.75H8.918a.75.75 0 0 1 0-1.5h11.334a.75.75 0 0 1 .75.75m-.75 7.75a.75.75 0 1 0 0-1.5H8.919a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentRight24);
